import { FC, HTMLAttributes } from 'react';

export const ReactComponent: FC<HTMLAttributes<SVGElement>> = (props) => (
  <svg
    {...props}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17 16C17 16.5523 16.5523 17 16 17H4C3.44772 17 3 16.5523 3 16V7H17V16ZM10 8C9.72386 8 9.5 8.22386 9.5 8.5V12.5L9.50977 12.6006C9.54966 12.7961 9.70392 12.9503 9.89941 12.9902L10 13H13C13.2761 13 13.5 12.7761 13.5 12.5C13.5 12.2239 13.2761 12 13 12H10.5V8.5C10.5 8.22386 10.2761 8 10 8ZM14 2C14.5523 2 15 2.44772 15 3H16C16.5523 3 17 3.44772 17 4V6H3V4C3 3.44772 3.44772 3 4 3H5C5 2.44772 5.44772 2 6 2C6.55228 2 7 2.44772 7 3H13C13 2.44772 13.4477 2 14 2Z"
      fill="#F2994A"
    />
  </svg>
);
